// extracted by mini-css-extract-plugin
module.exports = {"truncated":"BookingCounter_truncated__Js_cr","root":"BookingCounter_root__s8Oeq"};